import navigation from "@/lang/es/navigation";
import generics from "@/lang/es/generics";
import questions from "@/lang/es/questions";
import a11y from "@/lang/es/a11y";
import velt from "@/lang/es/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
